import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/Warning.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  height: "100",
  alt: "Alerta"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "popUpDD"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Nos estamos renovando para brindarte una experiencia única y para lograrlo nuestro aliado ha cambiado. No te preocupes, esto no afectará ninguna de las funcionalidades de nuestro portal, sin embargo, es necesario que realices el proceso de habilitación ante la DIAN y así continuar disfrutando de nuestros servicios. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " ¿Deseas realizar el proceso de habilitación? ")
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Gracias por elegir Aportes en Línea. Actualmente no podemos procesar la transmisión, ya que no has realizado el proceso de habilitación. Para habilitarte da clic en Aceptar. ", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Gracias por elegir Aportes en Línea. En este momento no es posible continuar con la compra de planes para el servicio de Nómina Electrónica. Para completar tu compra, es necesario que realices el proceso de habilitación. Para habilitarte da clic en Aceptar. ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: "",
    closable: false,
    header: "Importante",
    draggable: false,
    id: "p-dialog"
  }, {
    footer: _withCtx(() => [
      ($props.habProcesoRestringido == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_Button, {
              class: "SinoBtn",
              onClick: $setup.CerrarModal,
              text: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("No")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "SinoBtn",
              onClick: $setup.RedirigirHabilitacion,
              text: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Si")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      ($props.habProcesoRestringido != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (!$setup.sinSalidaDePlans)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "HabBtn",
                  onClick: $setup.CerrarModal,
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("← Volver")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              class: "HabBtn",
              onClick: $setup.RedirigirHabilitacion,
              text: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aceptar")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 20,
            sm: 20,
            md: 20,
            lg: 20,
            xl: 20
          }, {
            default: _withCtx(() => [
              ($props.habProcesoRestringido == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                : _createCommentVNode("", true),
              ($props.habProcesoRestringido == 'Transmision' || $props.habProcesoRestringido == 'Ajuste')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
              ($props.habProcesoRestringido == 'Planes')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}